<template>
  <v-btn
    class="take-button"
    :title="disabled ? 'No Scene Cued' : 'Start the Take'"
    @click="handleTake"
    color="primary"
    :disabled="disabled"
    prepend-icon="mdi-chevron-double-right">
    Take
  </v-btn>
</template>
<script setup>
import { computed } from 'vue';
import { $http } from '../../../stores/http';

const props = defineProps(['channelUid', 'disabled']);
const takeUrl = computed(
  () => `/dynamic_engine/take/channel/${props.channelUid}`
);

async function handleTake() {
  await $http('POST', takeUrl.value);
  console.log('channel taking:', props.channelUid);
}
</script>
<style scoped>
.take-button[disabled] {
  cursor: not-allowed;
  cursor: default;
  pointer-events: auto;
}
</style>
